/**
 * 산업 분야 목록
 * KSGC 지원서에서 사용되는 산업 분야 옵션들
 */
export const industryList = [
  "IT & Software",
  "e-Commerce & Retail",
  "Healthcare & Bio",
  "Metaverse & Media",
  "ESG & Green Tech",
  "Food Tech & Agri Tech",
  "Mobility & Robotics",
  "Manufacturing & IoT",
  "Etc"
]; 